import { SHOW_HELP, HIDE_HELP } from "../actions/types";

const initialState = { open: false, screen: "" };

//Handling Datasources
export const helpReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SHOW_HELP:
      return { open: true, screen: payload };
    case HIDE_HELP:
      return initialState;
    default:
      return state;
  }
};
